let $ = require("jquery");

$(function () {
  if (GwpEnable) {
  }

  gwp_popup();
  function fnAddGWPtoCart(cart) {
    check_id = gwp_product,
      hasFreeProduct = cart.items.filter((item) => {
        return item.properties && item.product_id == check_id && item.properties._gwp_product == "yes";
      });
    var id = $(".gwp_variant option.selected").data("id");
    if (window.gwp_product_sku) {
      var gwp_sku = window.gwp_productJson.variants.filter((v) => { return v.sku == window.gwp_product_sku; });
      if (gwp_sku.length > 0) {
        id = gwp_sku[0].id;
      }
      // console.log('gwp_sku', gwp_sku)
    }
    if (hasFreeProduct.length == 0) {
      if (id != undefined) {
        $(this).text("Loading..");
        var addData = {
          id: id,
          quantity: 1,
          properties: {
            _gwp_product: "yes",
          },
        };

        fetch("/cart/add.js", {
          body: JSON.stringify(addData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            console.log('final cart after gpw added: ')
            if (window.gwp_product_sku) { }
            else {
              $(".content_pro").removeClass("show");
              $(".content_thanku").addClass("show");
            }
            var count = parseInt($(".cart-count:eq(0)").text());
            count = count + 1;
            $(".cart-count").text(count);
            // $(".mobile-menu .cart .cart-count").text(count);
            setTimeout(() => {
              $(this).text("Add to Cart");
            }, 200);

            if ($("body").hasClass("template-cart")) {
              cartMockup();
            }
          })
          .catch(function (err) {
            console.error(err);
          });
      } else {
        alert("Please select a size");
      }
    } else {
      if (window.gwp_product_sku) { }
      else {
        $(".content_pro").removeClass("show");
        $(".content_thanku").addClass("show");
      }
      cartMockup();
    }
    console.log('hasFreeProduct', hasFreeProduct);
  }
  function gwp_popup() {
    console.log('window.gwp_type', window.gwp_type)
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        var check_id = gwp_product;
        // console.log('cart',cart)
        if (window.gwp_type == 'product_select') {
          var found = false;
          var hasGwp = cart.items.filter((item) => {
            return item.product_id == check_id;
          });
          var hasFreeProduct = cart.items.filter((item) => {
            return item.properties && item.product_id == check_id && item.properties._gwp_product == "yes";
          });
          for (let index = 0; index < window.gwp_eligible_prods.length; index++) {
            const element = window.gwp_eligible_prods[index];
            found = cart.items.filter((c) => { return c.handle == element.handle });
            if (found.length > 0) {
              break;
            }
          }
          // console.log('fount item ', found, 'hasFreeProduct: ', hasFreeProduct);
          if (window.gwp_product_sku != '') {
            //if there is Single variants for GWP popup, so gwp should auto add to cart
            if (found.length > 0 && hasFreeProduct.length == 0) {
              fnAddGWPtoCart(cart);
            }
            else if (found.length == 0 && hasFreeProduct.length > 0) {
              //removeGWP from cart if no eligible product found
              removeGWP(hasFreeProduct[0].id, (refresh = refresh));
            }
          }
          else {
            //if there is multi variants for GWP popup
            if (found.length > 0 && hasFreeProduct.length == 0 && window.gwp_product_sku == '') {
              //show GWP popup here
              console.log('show GWP popup here')
              $(".content_pro").addClass("show");
              $("body").addClass("body_hidden");
            }
            else if (found.length == 0 && hasFreeProduct.length > 0) {
              //removeGWP from cart if no eligible product found
              removeGWP(hasFreeProduct[0].id, (refresh = refresh));
            }
          }

        }
        else {
          var cart_total = cart.items_subtotal_price,
            cart_total = cart.total_price;

          var hasFreeProduct = cart.items.filter((item) => {
            return item.properties && item.product_id == check_id && item.properties._gwp_product == "yes";
          }),
            hasGwp = cart.items.filter((item) => {
              return item.product_id == check_id;
            }),
            refresh = true;
          //   console.log('cart_total',cart_total)
          console.log('hasGWP', hasGwp[0])
          if (GwpEnable && cart_total > gwp_threshold && hasFreeProduct.length == 0 && hasGwp.length == 0) {
            $(".content_pro").addClass("show");
            $("body").addClass("body_hidden");
          } else if (cart_total > gwp_threshold && hasGwp.length && hasFreeProduct.length == 0 && GwpEnable && window.GwpEnable) {
            updateToGWP(hasGwp[0].key, { _gwp_product: "yes" }, (refresh = refresh));
          } else if (cart_total < gwp_threshold && hasFreeProduct.length) {
            // updateToGWP(hasGwp[0].key ,{ "_gwp_product": " " } ,refresh = refresh);
            removeGWP(hasFreeProduct[0].id, (refresh = refresh));
          }
        }

      });
  }
  function removeGWP(id, refresh) {
    fetch(`/cart/change.js?id=${id}`, {
      method: "POST",
      body: JSON.stringify({
        quantity: 0,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        //   console.log('Product removed from cart successfully:', data);

        if ($("body").hasClass("template-cart")) {
          cartMockup();
        }
      })
      .catch((error) => {
        console.error("Error removing product from cart:", error);
      });
  }
  function updateToGWP(id, properties, refresh) {
    // console.log('here we go',id , qty)
    fetch(`/cart/change.js`, {
      method: "POST",
      body: JSON.stringify({
        id: id,
        properties: properties,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        //   console.log('Line item properties updated successfully:', data);
        if ($("body").hasClass("template-cart")) {
          cartMockup();
        }
      })
      .catch((error) => {
        console.error("Error updating line item properties:", error);
      });
  }
  $("body").on("click", ".gwp_atc", function () {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log('cart', cart)

        fnAddGWPtoCart(cart);
      })
  });
  $("body").on("click", ".custom-size-overlay-header .close", function () {
    $("body").removeClass("custom-size-selection-shown");
  });

  $("body").on("click", ".popup_close", function () {
    $(".content_pro").removeClass("show");
    $("body").removeClass("body_hidden");
  });
  $("body").on("click", ".success_close", function (e) {
    e.preventDefault();
    $("body").removeClass("body_hidden");
    $(".content_thanku").removeClass("show");
    if ($("body").hasClass("template-cart")) {
      location.reload(true);
      cartMockup();
    }
  });

  $(".custom-size-selection-toggle").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("custom-size-selection-shown");
    $(this).attr("aria-expanded", true);
    window.helpers.triggerEl = $(this);
    window.helpers.trapFocus(".custom-size-selection-overlay");
  });

  $(".custom-size-overlay-options button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".custom-size-overlay-options button").removeClass("selected");
    $(this).addClass("selected");
    // $("#size-selection").val($(this).data("value")).trigger("change");
    var sizeNo = $(this).attr("data-size-no"),
      sizeText = $(this).data("text");
    var sizeLable = sizeNo.length ? `${sizeText} ${sizeNo}` : `${sizeText}`;
    console.log(sizeLable)
    $(".custom-size-selection-toggle").text(sizeLable);
    $(this).parents(".pro_variant").find(`select option`).removeClass("selected");
    var current_var = $(this).parents(".pro_variant").find(`select option[data-text='${sizeLable}']`);
    console.log("current_var", current_var);
    current_var.addClass("selected");
    $("body").removeClass("custom-size-selection-shown");
  });

  $('body').on('click', '.nosto-atc', function () {
    if (GwpEnable) {
      setTimeout(() => {
        if (window.gwp_product_sku) {
          console.log('GWP should auto added');
        }
        else {
          gwp_popup();
        }
      }, 1000)
    }
  })

  $(document).on("AjaxAdded", function (event, cart) {
    if (GwpEnable) {
      gwp_popup();
    }
    if ($("body").hasClass("template-cart")) {
      cartMockup();
    }
  });
  function cartMockup() {
    $.ajax({
      url: "/cart?view=ajax-view",
      method: "GET",
      headers: {
        "Content-Type": "application/html",
        "X-Requested-With": "xmlhttprequest",
        "Access-Control-Allow-Origin": "*",
      },
      success: function (response) {
        $(".cart-contents-container").html(response);
      },
      error: function (error) {
        console.error("Error fetching cart:", error);
      },
    });
  }
});
